import { XIcon } from "@heroicons/react/solid";
import React, {useEffect, useState } from "react";
import { v4 as uuid } from "uuid";

export default function AddNewGroup({close, type, editData}) {
  const DEFAULT_VALUES = {
    ledger_uuid: type==='New'? '' : editData.ledger_uuid,
    ledger_title: type==='New'? '' : editData.ledger_title,
    outlet_uuid: type==='New'? '' : editData.outlet_uuid,
    ledger_group_uuid: type==='New'? '' : editData.ledger_group_uuid,
    mobile: type==='New'? '' : editData.mobile,
    remarks: type==='New'? '' : editData.remarks,
    date: type==='New'? '' : editData.opening_balance[0].date,
    balance: type==='New'? '' : editData.opening_balance[0].balance,
  }
  const [ledgerData, setLedgerData] = useState(DEFAULT_VALUES);
  const [ledgerGroups, setLedgerGroups] = useState([]);

  useEffect(() => {
    const getLedgerGroups = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/acLedgerGroup/ListLedgerGroup`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
      .then(res => res.json())
      .then(data => {
        setLedgerGroups(data);
      })
      .catch(err => console.warn("post request failed", err));
    }
    getLedgerGroups();
  }, [])

  const handleSave = async (e)=>{
    e.preventDefault();
    const json = {
      ledger_uuid: uuid(),
      ledger_title: ledgerData.ledger_title,
      outlet_uuid: localStorage.getItem("outlet_uuid"),
      ledger_group_uuid: ledgerData.ledger_group_uuid,
      mobile: ledgerData.mobile,
      remarks: ledgerData.remarks,
      opening_balance: [
        {
          date: '1648771200000',
          balance: ledgerData.balance
        }
      ]
    }
    const url = `https://api.myfooddo.com/acLedger/CreateLedger`;
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify([json]),
    })
    .then(res => res.json())
    .then(data => {
      console.log("CreateLedger...", data);
    })
    .catch(err => console.warn("post request failed", err));
    close()
  }
  
  const handleEdit = async (e)=>{
    e.preventDefault();
    const json = {
      ledger_uuid: ledgerData.ledger_uuid,
      ledger_title: ledgerData.ledger_title,
      outlet_uuid: ledgerData.outlet_uuid,
      ledger_group_uuid: ledgerData.ledger_group_uuid,
      mobile: ledgerData.mobile,
      remarks: ledgerData.remarks,
      opening_balance: [
        {
          date: '1648771200000',
          balance: ledgerData.balance
        }
      ]
    }
    const url = `https://api.myfooddo.com/acLedger/EditLedger`;
    // console.log(url, json);
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify([json]),
    })
    .then(res => res.json())
    .then(data => {
      console.log("EditLedger...", data);
    })
    .catch(err => console.warn("post request failed", err));
    close()
  }

  return (
    <div className='newCategory' draggable={false}>
      <div className='newCatContainer'>
        <div className='newCatContainer_header'>
          <h2>Ledger</h2>
          <XIcon className='closeicon' onClick={close} />
        </div>
        <form className='newCatContainer2' action='' onSubmit={type==='New'? handleSave : handleEdit}>
          <div className='cat-inp'>
            <label htmlFor='ledgerName'>Ledger Name</label>
            <input
              value={ledgerData.ledger_title}
              onChange={(e) => setLedgerData( {
                ...ledgerData,
                ledger_title: e.target.value
              })}
              maxLength={40}
              type='text'
              required
              id='ledgerName'
            />
          </div>
          <div className='cat-inp'>
            <label htmlFor='ledgerGroup'>Ledger Group</label>
            <select
              required
              value={ledgerData.ledger_group_uuid}
              onChange={e=>setLedgerData({
                ...ledgerData,
                ledger_group_uuid: e.target.value,
              })}
            >
                <option key={'i0'} value='' disabled selected>Select group</option>
              {ledgerGroups.length>0 && ledgerGroups.map((group, i)=>
                <option key={i.toString()} value={group.ledger_group_uuid}>{group.ledger_group_title}</option>
              )}
            </select>
          </div>
          <div className='cat-inp'>
            <label htmlFor='mobile'>Mobile</label>
            <input
              value={ledgerData.mobile}
              onChange={(e) => setLedgerData( {
                ...ledgerData,
                mobile: e.target.value
              })}
              maxLength={10}
              type='text'
              pattern= "[0-9]+"
              id='mobile'
            />
          </div>
          <div className='cat-inp'>
            <label htmlFor='remarks'>Remarks</label>
            <input
              value={ledgerData.remarks}
              onChange={(e) => setLedgerData( {
                ...ledgerData,
                remarks: e.target.value
              })}
              maxLength={200}
              type='text'
              id='remarks'
            />
          </div>
          <div className='cat-inp'>
            <label htmlFor='balance'>Opening Balance</label>
            <input
              value={ledgerData.balance}
              onChange={(e) => setLedgerData( {
                ...ledgerData,
                balance: e.target.value
              })}
              maxLength={10}
              type='number'
              id='balance'
            />
          </div>
          {type === "New" ? (
            <button type='submit' >Save</button>
          ) : (
            <button type='submit' >Update</button>
          )}
        </form>
      </div>
    </div>
  );
}
